export default function setFormReadyParam(param) {
  // Выставляет переменную для QA автотестов
  window._ottFormsReady = {};
  window._ottFormsReady[param] = true;
}
